export const PAGINATION = {
  page: 1,
  size: 10,
}

/** 规则类型 */
export const RULE_TYPE = {
  NEW_USER_7_DAYS: 'NEW_USER_7_DAYS',
  SPECIFIED_USER: 'SPECIFIED_USER',
  SPECIFIED_PARTNER: 'SPECIFIED_PARTNER',
  CUSTOM_TIME: 'CUSTOM_TIME',
  ALL_USER: 'ALL_USER',
}

export const RULE_TYPE_OPTIONS = [
  { label: '七天新用户', value: RULE_TYPE.NEW_USER_7_DAYS },
  { label: '指定用户', value: RULE_TYPE.SPECIFIED_USER },
  { label: '指定合伙人', value: RULE_TYPE.SPECIFIED_PARTNER },
  { label: '自定义时间', value: RULE_TYPE.CUSTOM_TIME },
  { label: '所有用户', value: RULE_TYPE.ALL_USER },
]

export const RULE_TYPE_MAP = RULE_TYPE_OPTIONS.reduce((map, item) => {
  map[item.value] = item.label
  return map
}, {})

/** 规则连接关系：0=无，1=且，2=或 */
export const LOGIC_TYPE = {
  NONE: 0,
  AND: 1,
  OR: 2,
}

export const LOGIC_TYPE_OPTIONS = [
  { label: '且', value: LOGIC_TYPE.AND },
  { label: '或', value: LOGIC_TYPE.OR },
]

export function needUidText(ruleType) {
  return (
    ruleType === RULE_TYPE.SPECIFIED_USER ||
    ruleType === RULE_TYPE.SPECIFIED_PARTNER
  )
}

export function needRuleTime(ruleType) {
  return ruleType === RULE_TYPE.CUSTOM_TIME
}

export function createEmptyRule(sortNo = 1) {
  return {
    ruleType: '',
    uidText: '',
    ruleTime: null,
    sortNo,
    logicType: LOGIC_TYPE.NONE,
  }
}
